export default __webpack_public_path__ + "static/media/4-Pre-Listing-Agent.342f14f4.png";